<div class="dialog-content-max">
    <form [formGroup]="cityform">
        <div class="formgrid grid">
            <div class="field col-12">
                <label for="name" class="required-label">City Name<span class="maxchars">(Max 100 chars)</span><span>*</span></label> 
                <input type="text" class="form-control" id="name" inputId="name" placeholder="Enter City Name"
                    name="name" formControlName="name" required>
                <span class="errormessage"
                    *ngIf="cityform.get('name').invalid && (cityform.get('name').dirty || cityform.get('name').touched)">
                    {{ getErrorMessage(cityform, validation_message, 'name') }}
                </span>
            </div>

        </div>

        <div class="formgrid grid" *ngIf="isEdit">
            <div class="field col-12 lg:col-12 md:col-12 sm:col-12">
                <label for="activeflag">Active Flag <span
                        style="color: rgb(222, 30, 30); font-weight: bold;">*</span></label>
                <p-dropdown [options]="activeFlag" inputId="activeflag" [filter]="true" appendTo="body"
                    name="activeflag" optionLabel="labelname" optionValue="value" placeholder="Select Flag"
                    formControlName="activeflag"></p-dropdown>
                <span style="color:red"
                    *ngIf="cityform.get('activeflag').invalid  && cityform.get('activeflag').touched">
                    {{getErrorMessage(cityform,validation_message,'activeflag')}}
                </span>

            </div>
        </div>
    </form>

    <div class="custom-dialog-footer">
        <p-button class="m-1" label="Close" styleClass="customeclose"
            (click)="closemodal(cityform,this.ref,'Are you sure you want to close?')"></p-button>

        <p-button class="m-1" *ngIf="!onlyView" label="{{saveTitle}}" styleClass="customesave" (click)="add()">
        </p-button>
    </div>
</div>